/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../../theme/commonStyle";

export const advocardFlexCheckinStyles = {
  scrollToAnchor: {
    ...scrollToAnchor,
    /** Header is higher on page ~112px */
    top: "-112px"
  },
  formPaper: {
    padding: { xs: "20px", md: "20px 40px" },
  },
  errorMessage: {
    textAlign: "center",
    margin: "1px",
    color: "primary.main",
    fontWeight: 400,
  },
  button: {
    marginTop: "3px",
    color: "primary",
  },
};
